import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-dashboard-summary-card',
    templateUrl: './dashboard-summary-card.component.html',
    styleUrls: ['./dashboard-summary-card.component.scss'],
    standalone: false
})
export class DashboardSummaryCardComponent {
    @Input() title: string = '';
    @Input() value: number | string = 0;
    @Input() icon: string = 'info';
    @Input() color: string = 'primary'; // primary, success, warning, danger, info
    @Input() routerLink: string | any[] | null = null;
    @Input() trend?: { value: number; isPositive: boolean };
    @Input() unit: string = ''; // e.g., '$', '%'

    constructor() { }
}
